import { useSelector } from 'react-redux'
import { Scatter, ScatterChart, ZAxis } from 'recharts'
import { CalculateSize } from '../../../../../../../common/CalculateSize'
import { ChartContainer } from '../../../../../../../common/chart/chartContainer'
import { Legend } from '../../../../../../../common/chart/legend'
import { Loading } from '../../../../../../../common/loading'
import { Notification } from '../../../../../../../common/notification'
import { SCREEN } from '../../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { formatText, formatVal } from '../../../../../../../helpers/value'
import { CustomTooltip } from '../../../customTooltip'
import { formatDataForChart } from '../../../helpers'
import {
  selectIsLoading,
  selectIsShowData,
  selectRawData,
  selectYears,
} from '../../store/slice'

export const ChartGrowthFDI = () => {
  const { formatCurrencyWithUnit } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  const data = useSelector(selectRawData)
  const isLoading = useSelector(selectIsLoading)
  const years = useSelector(selectYears)
  const locale = useSelector((state) => state.i18n.locale)
  const isShowData = useSelector(selectIsShowData)

  const [data1, data2] = formatDataForChart(years, data)

  if (isLoading) {
    return (
      <div className="h100 positionRelative">
        <Loading />
      </div>
    )
  }

  if (!data1.length && !data2.length) {
    return <Notification />
  }

  return (
    <div className="flexColumn h100">
      <div className="flex1 positionRelative">
        <CalculateSize height="100%">
          {(size) => {
            return (
              <ChartContainer
                chartType={ScatterChart}
                data={[...data1, ...data2]}
                width={'100%'}
                height={size.height}
                xAxis={[
                  {
                    dataKey: 'year',
                    allowDuplicatedCategory: false,
                    tickPosition: (props) => {
                      return { x: props.x - props.tickWidth / 2, y: props.y }
                    },
                  },
                ]}
                yAxis={[
                  {
                    yAxisId: 'left',
                    dataKeys: ['value'],
                    dataKey: 'value',
                    unit: '%',
                    isScatterChart: true,
                    tickFormatter: (value) => formatVal(value * 100, locale),
                  },
                ]}
                tooltip={{
                  schema: {
                    renderCustomContent: ({ data }) => {
                      return (
                        <CustomTooltip
                          label={data.year}
                          list={[
                            {
                              label: data.name,
                              value: '',
                            },
                            {
                              label: 'industryOverview.macroeconomics.VALUE',
                              isI18n: true,
                              value: data.realValue,
                              formatValue: (value) =>
                                formatCurrencyWithUnit({
                                  value,
                                  year: data.year,
                                  exchangeRateType: 'averageRate',
                                }),
                            },
                            {
                              label:
                                'industryOverview.macroeconomics.GROWTH_RATE',
                              isI18n: true,
                              value: data.value,
                              unit: '%',
                              formatValue: (val) =>
                                formatVal(val * 100, locale),
                            },
                          ]}
                        />
                      )
                    },
                  },
                }}
              >
                {isShowData && (
                  <>
                    <ZAxis
                      zAxisId={'zAxisId'}
                      dataKey={'realValue'}
                      range={[1000, 3000]}
                    />
                    <Scatter
                      data={data1}
                      yAxisId="left"
                      zAxisId={'zAxisId'}
                      fill="#C06C84"
                    />
                  </>
                )}
                <ZAxis
                  zAxisId={'zAxisId2'}
                  dataKey={'realValue'}
                  range={[100, 300]}
                />
                <Scatter
                  data={data2}
                  yAxisId="left"
                  zAxisId={'zAxisId2'}
                  fill="#B3CC85"
                />
              </ChartContainer>
            )
          }}
        </CalculateSize>
      </div>
      <Legend
        className="dFlex justifyContentCenter"
        style={{ gap: 40 }}
        items={
          isShowData
            ? [
                { key: 1, color: '#C06C84', title: formatText(data1[0]?.name) },
                { key: 2, color: '#B3CC85', title: formatText(data2[0]?.name) },
              ]
            : [{ key: 1, color: '#B3CC85', title: formatText(data2[0]?.name) }]
        }
      />
    </div>
  )
}
